const SoccerLigaMx = (props) => {
  return (
    <svg
      version="1.1"
      id="svg2"
      {...props}
      viewBox="0 0 1056 616"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs id="defs6">
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath16">
          <path d="M 0,612 H 792 V 0 H 0 Z" id="path14" />
        </clipPath>
      </defs>
      <g id="g8" transform="matrix(1.3333333,0,0,-1.3333333,0,816)">
        <g id="g10">
          <g id="g12" clipPath="url(#clipPath16)">
            <g id="g18" transform="translate(448.3604,376.2725)">
              <path
                d="m 0,0 c 0,0 45.092,63.03 48,73.212 0,0 23.273,20.849 -16,41.697 0,0 -41.211,17.94 -63.029,-1.939 0,0 -73.213,-65.455 -95.032,-98.91 0,0 -12.605,-14.545 1.94,-32 0,0 58.255,-83.881 125.128,-157.578 0,0 23.811,-24.726 65.706,7.274 0,0 27.833,22.302 9.409,54.787 0,0 -43.638,81.458 -76.122,113.457"
                fill={props?.color ?? "currentColor"}
                style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                id="path20"
              />
            </g>
            <g id="g22" transform="translate(227.979,156.7539)">
              <path
                d="M 0,0 H 12.038 V -35.755 H 34.921 V -46.601 H 0 Z"
                style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                id="path24"
                fill={props?.color ?? "currentColor"}
              />
            </g>
            <path
              d="m 268.144,156.754 h 13.587 v -46.601 h -13.587 z"
              style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
              fill={props?.color ?? "currentColor"}
              id="path26"
            />
            <g id="g28" transform="translate(322.3066,121.874)">
              <path
                d="m 0,0 c -2.216,-1.306 -4.847,-2.063 -7.669,-2.063 -7.895,0 -14.296,5.922 -14.296,13.227 0,7.305 6.401,13.227 14.296,13.227 3.948,0 7.522,-1.481 10.109,-3.874 l 7.793,8.447 c -4.692,4.041 -10.985,6.514 -17.902,6.514 -14.514,0 -26.28,-10.886 -26.28,-24.314 0,-13.428 11.766,-24.313 26.28,-24.313 7.61,0 14.464,2.992 19.264,7.774 l 0.031,20.591 H -9.231 V 6.039 h 9.177 z"
                style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                fill={props?.color ?? "currentColor"}
                id="path30"
              />
            </g>
            <g id="g32" transform="translate(358.2861,128.8896)">
              <path
                d="M 0,0 H 9.745 L 4.873,11.321 Z M -1.29,28.462 H 11.178 L 30.525,-18.774 H 17.341 l -2.723,8.742 H -4.156 l -3.439,-8.742 H -21.21 Z"
                style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                fill={props?.color ?? "currentColor"}
                id="path34"
              />
            </g>
            <g id="g36" transform="translate(413.3174,156.6914)">
              <path
                d="M 0,0 H 13.185 L 27.086,-16.768 41.99,0 H 54.745 V -46.576 H 40.7 v 26.799 L 26.513,-33.965 13.901,-19.634 v -26.942 l -13.901,0 z"
                style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                fill={props?.color ?? "currentColor"}
                id="path38"
              />
            </g>
            <g id="g40" transform="translate(476.2324,156.6914)">
              <path
                d="M 0,0 H 18.057 L 26.655,-11.752 36.114,0 h 17.627 l -16.91,-21.927 19.347,-24.649 h -18.2 L 27.229,-33.105 16.337,-46.576 H -2.007 l 19.778,24.362 z"
                style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                fill={props?.color ?? "currentColor"}
                id="path42"
              />
            </g>
            <g id="g44" transform="translate(564.1846,477.8398)">
              <path
                d="m 0,0 c 0,0 -32.542,22.203 -43.491,-10.34 0,0 -1.826,-14.904 8.211,-29.806 0,0 97.095,-93.694 69.095,-194.694 0,0 84.37,119.68 -33.815,234.84"
                style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                fill={props?.color ?? "currentColor"}
                id="path46"
              />
            </g>
            <g id="g48" transform="translate(535.6367,411.4834)">
              <path
                d="m 0,0 c 0,0 -33.738,21 -58.182,-7.229 0,0 -17.842,-23.23 -5.589,-45.719 0.138,-0.253 0.28,-0.505 0.425,-0.758 13.082,-22.721 54.051,-59.213 76.084,-119.805 0,0 9.294,-31.673 41.312,11.017 0,0 24.789,26.509 -5.852,88.821 0,0 -23.755,49.918 -48.198,73.673"
                style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                fill={props?.color ?? "currentColor"}
                id="path50"
              />
            </g>
            <g id="g52" transform="translate(312.1519,376.2725)">
              <path
                d="m 0,0 c 0,0 -45.091,63.03 -48,73.212 0,0 -23.273,20.849 16,41.697 0,0 41.212,17.94 63.03,-1.939 0,0 73.213,-65.455 95.031,-98.91 0,0 12.606,-14.545 -1.939,-32 0,0 -58.255,-83.881 -125.128,-157.578 0,0 -23.812,-24.726 -65.706,7.274 0,0 -27.834,22.302 -9.41,54.787 0,0 43.638,81.458 76.122,113.457"
                style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                fill={props?.color ?? "currentColor"}
                id="path54"
              />
            </g>
            <g id="g56" transform="translate(196.1938,477.8398)">
              <path
                d="m 0,0 c 0,0 32.542,22.203 43.491,-10.34 0,0 1.826,-14.904 -8.211,-29.806 0,0 -97.095,-93.694 -69.095,-194.694 0,0 -84.37,119.68 33.815,234.84"
                style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                fill={props?.color ?? "currentColor"}
                id="path58"
              />
            </g>
            <g id="g60" transform="translate(224.7417,411.4834)">
              <path
                d="m 0,0 c 0,0 33.738,21 58.182,-7.229 0,0 17.842,-23.23 5.589,-45.719 -0.138,-0.253 -0.28,-0.505 -0.425,-0.758 -13.082,-22.721 -54.051,-59.213 -76.084,-119.805 0,0 -9.294,-31.673 -41.312,11.017 0,0 -24.789,26.509 5.852,88.821 0,0 23.755,49.918 48.198,73.673"
                style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                fill={props?.color ?? "currentColor"}
                id="path62"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default SoccerLigaMx;
